/** Neutral colors that are common across apps. Here they are ordered from lightest to darkest */

export const appNeutralColors = {
  white: "#FFFFFF",
  gray10: "#FAF9F8",
  gray20: "#F3F2F1",
  gray30: "#EDEBE9",
  gray40: "#E1DFDD",
  gray50: "#D2D0CE",
  gray60: "#C8C6C4",
  gray70: "#BEBBB8",
  gray80: "#B3B0AD",
  gray90: "#A19F9D",
  gray96: "#F5F5F5",
  gray100: "#979593",
  gray110: "#8A8886",
  gray120: "#797775",
  gray130: "#605E5C",
  gray140: "#484644",
  gray150: "#3B3A39",
  gray160: "#323130",
  gray170: "#292827",
  gray180: "#252423",
  gray190: "#201f1E",
  gray200: "#1B1A19",
  gray210: "#161514",
  gray220: "#11100F",
  gray230: "#616161",
  gray240: "#bdbdbd",
  gray250: "#242424",
  black: "#000000",
};
